import { Component, OnInit, Output, EventEmitter} from '@angular/core';
import { UserService } from '../../../_services/user.service';

declare var jQuery: any;
import '../../../../assets/semantic/semantic.min.js';

@Component({
  selector: 'app-delete-user',
  templateUrl: './delete-user.component.html',
  styleUrls: ['./delete-user.component.css']
})

export class DeleteUserComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();

  private to_delete;
  private email;

  constructor(private service: UserService) { }
  
  ngOnInit() { }
  
  openModal(user_id, email) {
    this.to_delete = user_id;
    this.email = email;
    jQuery('#deleteConfirmation').modal('show');
  }
  deleteUser() {
    if (!this.to_delete) {
      jQuery('#deleteConfirmation').modal('hide');
      return false;
    }
    
    let user_id = this.to_delete;
    this.to_delete = undefined;

    jQuery('#deleteConfirmation').modal({ closable: false });
    this.service.deleteUser(user_id).subscribe(response => {
      jQuery('#deleteConfirmation').modal('hide');
      this.refresh.emit(true);
    })

  }
}


// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/user/delete-user/delete-user.component.ts